import { useContext } from 'react';
import { SelectionsD1ConferencesStateContext } from './SelectionsD1ConferencesContextProvider';
import SelectionsD1ConferencesData from './SelectionsD1ConferencesData';

const useSelectionsD1ConferencesData = () => {
  const [selectionsD1ConferencesState, setSelectionsD1ConferencesState] = useContext(SelectionsD1ConferencesStateContext);
  
  const getSelectionsD1Conferences = () => {
    return SelectionsD1ConferencesData.getSelectionD1ConferencesData(selectionsD1ConferencesState, setSelectionsD1ConferencesState);
  };

  return {
    selectionsD1ConferencesState,
    setSelectionsD1ConferencesState,
    getSelectionsD1Conferences
  };
};

export default useSelectionsD1ConferencesData;